/**
 * Created by pandemio on 11/9/18.
 */
import React from 'react';
import { Input } from 'reactstrap';
import ApiCalls from '../../custom-classes/api-calls';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handles the selection of the available plans
 */
class SelectorPlan extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            options: [], // The options to fill the selection
            value: ''
        };
    }

    /**
     * Call the data API
     */
    callData(){
        // This is promise
        let apiCall = ApiCalls.getCommercialPlans();
        let arrOptions = [];

        // After the api call, fill the data
        apiCall.then((data)=>{

            // Translate the first selection
            arrOptions.push(
                <option key={"0"} value={"0"}>
                    <Translate id="plan-calculator-form.select-plan" options={{renderInnerHtml: false}}/>
                </option>);

            // Now fill the selections
            for (let i = 0; i < data.Plans.length; i++) {
                arrOptions.push(
                    <option key={data.Plans[i].PlanDescriptionByLang[0].PlanId} value={data.Plans[i].PlanDescriptionByLang[0].PlanId}>
                        { data.Plans[i].PlanDescriptionByLang[0].Name }
                    </option>
                );
            }
        }).then(() =>{
            this.setState({
                options: arrOptions
            });
        });
    }

    /**
     * Call the webservices for the subscription and fill those selects
     * Component did mount is required for selects with API calls.
     */
    componentWillMount()
    {
        this.callData();
    }

    /**
     * Handles the change event to get the selected value. Do not change this function
     * @param event The event (on change)
     */
    handleChange = (event) => {
        this.setState({value: event.target.value}, ()=>{
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render(){
        return (
            <Input type="select" className="form-control" name="plans" onChange={this.handleChange}>
                {this.state.options}
            </Input>
        )
    }
}

export default SelectorPlan;


// WEBPACK FOOTER //
// ./src/components/selectors/selector-plan.js